import styled from "styled-components/macro";
import { darkGrey, placeholderTextColor, lighterGrey } from "constants/colors";

export const TAGHIGHLIGHT_BACKDROP_HEIGHT = 24;
export const TAGHIGHLIGHT_BACKDROP_MARGIN_TOP = 4;
const TAG_HIGHLIGHT_PADDING_TOP_MULTIPLE_TIMELINES_PAGE =
  3 * TAGHIGHLIGHT_BACKDROP_MARGIN_TOP;
export const TAGHIGHLIGHT_SKU_OPERATOR_TIMELINE_ROW_GAP = 4;
export const TAGHIGHLIGHT_EXPANDED_OFFSET_TOP = 16;
export const TAG_HIGHLIGHT_ROW_CUBIC_BEZIER = `cubic-bezier(0.165, 0.84, 0.44, 1)`;

export const getTagHighlightHeightPlusPadding = (
  showTagHighlight,
  isHubletPage,
  isMultipleTimelinesPage
) =>
  !showTagHighlight
    ? 0
    : isHubletPage
      ? TAGHIGHLIGHT_BACKDROP_HEIGHT
      : isMultipleTimelinesPage
        ? TAGHIGHLIGHT_BACKDROP_HEIGHT +
          TAG_HIGHLIGHT_PADDING_TOP_MULTIPLE_TIMELINES_PAGE
        : 0;

export const TagHighlightTimelineBackdrop = styled.div<{
  $isDarkMode: boolean;
}>`
  pointer-events: none;
  background: ${({ $isDarkMode }) => ($isDarkMode ? darkGrey : lighterGrey)};
  height: ${TAGHIGHLIGHT_BACKDROP_HEIGHT}px;
  margin-top: ${TAGHIGHLIGHT_SKU_OPERATOR_TIMELINE_ROW_GAP}px;
  .placeholderText {
    height: 100%;
    color: ${placeholderTextColor};
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 12px;
  }
`;
/** just used as a spacer; associated backdrop rect is rendered in GreySubTimelineBackdrop */
export const SkuOperatorTimelineBackdrop = styled.div`
  visibility: hidden;
  height: ${TAGHIGHLIGHT_BACKDROP_HEIGHT}px;
  margin-top: ${TAGHIGHLIGHT_SKU_OPERATOR_TIMELINE_ROW_GAP}px;
`;
